import { jsx as r } from "react/jsx-runtime";
import { styled as i } from "@mui/material/styles";
import n from "@mui/material/Box";
import "@mui/material";
import { s } from "./spacings-C27fg6SF.js";
import { r as e } from "./roundings-rAN_HXvA.js";
const a = i(n)(({ theme: o }) => ({
  position: "relative",
  display: "flex",
  flexDirection: "row",
  alignItems: "stretch",
  justifyContent: "stretch",
  padding: o.spacing(s.xl),
  borderRadius: o.rounding(e.xl),
  border: `1px solid ${o.palette.grey[300]}`,
  backgroundColor: o.palette.common.white,
  width: "100%",
  overflow: "hidden"
})), g = ({ children: o, sx: t = void 0 }) => /* @__PURE__ */ r(a, { sx: t, children: o });
export {
  a as C,
  g as a
};
